import React, { useEffect, useState } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

// import Custom Components
import PageHeader from "../../common/page-header";
import Breadcrumb from "../../common/breadcrumb";
import { getAddress, getOrders } from "../../../api";
import ShiipingForm from "./Components/ShiipingForm";
import validateToken from "../../../utils/TokenValidator";
import HandleLogOut from "../../../handlers/HandleLogout";
import OrdersTable from "./Components/OrdersTable";

function DashBoard() {
  const [Address, setAddress] = useState([]);
  const [Orders, setOrders] = useState([]);

  const [editAddress, setEditAddress] = useState(false);
  const username = localStorage.getItem("Username");
  const Name = localStorage.getItem("name");
  const Email = localStorage.getItem("Email");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("tab");
  let indx;
  if (query === "Dashboard") {
    indx = 0;
  } else if (query === "Orders") {
    indx = 1;
  } else if (query === "Addresses") {
    indx = 2;
  } else if (query === "Account") {
    indx = 3;
  }
  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    handleScrollToTop();
    const { valid, expired } = validateToken();
    if (valid === false || expired === true) {
      window.location.href = "/login";
    }
    const FetchAddress = async () => {
      await getAddress().then((res) => {
        if (res[0]) {
          setAddress([res[0]]);
        }
      });
      await getOrders().then((res) => {
        setOrders(res.reverse());
      });
    };
    FetchAddress();
  }, []);
  const signoutHandle = () => {
    HandleLogOut();
    window.location.href = "/";
  };
  return (
    <>
      <Helmet>
        <title>LIBER | My Account</title>
      </Helmet>

      <h1 className="d-none">LIBER - My Account</h1>

      <div className="main">
        <PageHeader title="My Account" subTitle="Shop" />
        <Breadcrumb
          title="My Account"
          parent1={["Shop", "shop/sidebar/list"]}
          adClass="mb-3"
        />

        <div className="page-content">
          <div className="dashboard">
            <div className="container">
              <ul
                className="nav nav-dashboard flex-column mb-3 mb-md-0"
                role="tablist"
              >
                <Tabs selectedTabClassName="active show" defaultIndex={indx}>
                  <div className="row">
                    <aside className="col-md-4 col-lg-3">
                      <TabList>
                        <Tab className="nav-item">
                          <span className="nav-link">Dashboard</span>
                        </Tab>

                        <Tab className="nav-item">
                          <span className="nav-link">Orders</span>
                        </Tab>
                        {/* 
                                                <Tab className="nav-item">
                                                    <span className="nav-link">Downloads</span>
                                                </Tab> */}

                        <Tab className="nav-item">
                          <span className="nav-link">Addresses</span>
                        </Tab>

                        <Tab className="nav-item">
                          <span className="nav-link">Account Details</span>
                        </Tab>

                        <Tab className="nav-item">
                          <Link
                            to="#"
                            className="nav-link"
                            onClick={signoutHandle}
                          >
                            Sign Out
                          </Link>
                        </Tab>
                      </TabList>
                    </aside>

                    <div
                      className="col-md-8 col-lg-9"
                      style={{ marginTop: "1rem" }}
                    >
                      <div className="tab-pane">
                        <TabPanel>
                          {username ? (
                            <p>
                              Hello{" "}
                              <span className="font-weight-normal text-dark">
                                {username}
                              </span>
                              <br />
                              From your account dashboard you can view your{" "}
                              <a
                                href="/shop/dashboard?tab=Orders"
                                className="tab-trigger-link link-underline"
                              >
                                recent orders
                              </a>
                              , manage your{" "}
                              <a
                                href="/shop/dashboard?tab=Addresses"
                                className="tab-trigger-link"
                              >
                                shipping and billing addresses
                              </a>
                              , and{" "}
                              <a
                                href="/shop/dashboard?tab=Account"
                                className="tab-trigger-link"
                              >
                                edit your password and account details
                              </a>
                              .
                            </p>
                          ) : (
                            <p>Kindly Login</p>
                          )}
                        </TabPanel>

                        <TabPanel id="tab-orders">
                          {Orders ? (
                            Orders.length > 0 ? (
                              <OrdersTable Orders={Orders} />
                            ) : (
                              <>
                                <p>No order has been made yet.</p>
                                <Link
                                  to={`/shop`}
                                  className="btn btn-outline-primary-2"
                                >
                                  <span>GO SHOP</span>
                                  <i className="icon-long-arrow-right"></i>
                                </Link>
                              </>
                            )
                          ) : (
                            <>Loding</>
                          )}
                        </TabPanel>

                        <TabPanel id="tab-address">
                          <p>
                            The following addresses will be used on the checkout
                            page by default.
                          </p>

                          <div className="row">
                            <div className="col-lg-8">
                              <div className="card card-dashboard">
                                <div className="card-body">
                                  <h3 className="card-title">Address</h3>
                                  {Address ? (
                                    Address.length > 0 ? (
                                      Address.map((address) => (
                                        <p>
                                          {address.name ? (
                                            <>
                                              <strong> Name:</strong>{" "}
                                              {address.name}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.number ? (
                                            <>
                                              <strong>Address: </strong>
                                              {address.number}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.street ? (
                                            <>
                                              {" "}
                                              {address.street}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.city ? (
                                            <>
                                              <strong>City: </strong>
                                              {address.city}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.state ? (
                                            <>
                                              <strong>State: </strong>
                                              {address.state}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.country ? (
                                            <>
                                              <strong>Country: </strong>
                                              {address.country}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.pincode ? (
                                            <>
                                              <strong>Zipcode </strong>
                                              {address.pincode}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {address.phoneNumber ? (
                                            <>
                                              <strong>Ph No: </strong>
                                              {address.phoneNumber}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}

                                          {editAddress ? (
                                            <ShiipingForm
                                              setEditAddress={setEditAddress}
                                              isUpdate={true}
                                              id={address.id}
                                              setAddress={setAddress}
                                            />
                                          ) : (
                                            <>
                                              <div
                                                onClick={() =>
                                                  setEditAddress(true)
                                                }
                                              >
                                                Edit{" "}
                                                <i className="icon-edit"></i>
                                              </div>
                                            </>
                                          )}
                                        </p>
                                      ))
                                    ) : (
                                      <p>
                                        {editAddress ? (
                                          <ShiipingForm
                                            setEditAddress={setEditAddress}
                                            isUpdate={false}
                                            setAddress={setAddress}
                                          />
                                        ) : (
                                          <>
                                            You have not set up this type of
                                            address yet.
                                            <br />
                                            <div
                                              onClick={() =>
                                                setEditAddress(true)
                                              }
                                            >
                                              Edit <i className="icon-edit"></i>
                                            </div>
                                          </>
                                        )}
                                      </p>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>

                        <TabPanel>
                          <form action="#">
                            <div className="row">
                              <div className="col-sm-6">
                                <label> Name *</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={Name}
                                  disabled
                                />
                              </div>

                              <div className="col-sm-6">
                                <label>Username *</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={username}
                                  disabled
                                />
                                <small className="form-text">
                                  This will be how your name will be displayed
                                  in the account section and in reviews
                                </small>
                              </div>
                            </div>

                            {/* <label>Display Name *</label>
                                                        <input type="text" className="form-control" required /> */}

                            <label>Email address *</label>
                            <input
                              type="email"
                              className="form-control"
                              value={Email}
                              disabled
                            />

                            {/* <label>
                              Current password (leave blank to leave unchanged)
                            </label>
                            <input type="password" className="form-control" />

                            <label>
                              New password (leave blank to leave unchanged)
                            </label>
                            <input type="password" className="form-control" />

                            <label>Confirm new password</label>
                            <input
                              type="password"
                              className="form-control mb-2"
                            />

                            <button
                              type="submit"
                              className="btn btn-outline-primary-2"
                            >
                              <span>SAVE CHANGES</span>
                              <i className="icon-long-arrow-right"></i>
                            </button> */}
                          </form>
                        </TabPanel>
                      </div>
                    </div>
                  </div>
                </Tabs>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(DashBoard);
